


































import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';
import ButtonComponent from '@/shared/button/button.component.vue';
import CustomFieldService from '@/domain/custom-field/custom-field.service';
import TextField from '@/shared/text-field/text-field.component.vue';
import CustomFieldPersist from '@/domain/custom-field/custom-field.persist';
import SnackBarService from '@/shared/snackbar/snackbar.service';

@Component({ components: { ButtonComponent, TextField } })
export default class ProjectCustomFieldRegisterComponent extends Vue {
  @Prop() value!: boolean;

  @Prop() projectId!: string;

  customFieldName = '';


  get showDialog() {
    return this.value;
  }

  set showDialog(value: boolean) {
    this.$emit('input', value);
  }

  private closeModal() {
    this.showDialog = false;
    this.customFieldName = '';
  }

  confirm() {
    CustomFieldService
      .save(CustomFieldPersist.of(this.customFieldName, this.projectId))
      .then(() => this.saveSuccess())
      .catch(err => SnackBarService.errorMessage(err.response.data.messages));
  }

  saveSuccess() {
    this.closeModal();
    this.$emit('registered');
  }

  cancel() {
    this.closeModal();
  }
}
